/* import __COLOCATED_TEMPLATE__ from './qa-filter-empty-state.hbs'; */
/* RESPONSIBLE TEAM: team-fin-qa */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';

interface Signature {
  Args: {};
  Element: HTMLDivElement;
}

export default class QaFilterEmptyState extends Component<Signature> {
  @service declare intl: IntlService;

  get titleText() {
    return this.intl.t('inbox.search.qa-filter-empty-state.title');
  }

  get bodyText() {
    return this.intl.t('inbox.search.qa-filter-empty-state.body');
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Search::QaFilterEmptyState': typeof QaFilterEmptyState;
    'inbox2/search/qa-filter-empty-state': typeof QaFilterEmptyState;
  }
}
